import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { BoxStatus } from 'home/useSubBoxStatuses';
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt';
import { grey } from '@material-ui/core/colors';
import Tooltip from '@material-ui/core/Tooltip';

interface Props {
  status: BoxStatus;
}

const useStyles = makeStyles((theme: Theme) => ({
  '@keyframes blinker': {
    '50%': { opacity: 0 },
  },
  icon: {
    color: grey[500],
    fontSize: '1rem',
    animation: '$blinker 3s linear infinite',
  },
}));

const OfflineIcon = ({ status }: Props) => {
  const classes = useStyles();

  return !status.isOnline ? (
    <Tooltip title="オフライン">
      <OfflineBoltIcon className={classes.icon} />
    </Tooltip>
  ) : null;
};

export default OfflineIcon;
